function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScanOrder = function SvgScanOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.06899 21.6002H16.2192C18.7975 21.6002 20.8881 19.5095 20.8881 16.9314V5.86904C20.8881 3.29093 18.7975 1.2002 16.2192 1.2002H7.06899C4.49088 1.2002 2.40015 3.29093 2.40015 5.86904V16.9314C2.40015 19.5095 4.49088 21.6002 7.06899 21.6002Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3947 15.8421H7.89185M15.3947 11.2451H7.89185M10.7551 6.65869H7.89239",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgScanOrder;